import React from "react";
import BottomNavbar from "../components/BottomNavbar";
import Navbar from "../components/Navbar";
import { useSelector } from "react-redux";
import { RootState } from "../redux/Store";
import { Link } from "react-router-dom";

const Blog = () => {
  const posts = useSelector((state: RootState) => state.AllPost.posts);

  return (
    <>
      <Navbar current="blog" />
      <div className="max-w-7xl mx-auto px-4 py-24">
        {/* Page Title */}
        <h1 className="text-xl md:text-3xl font-bold text-center text-gray-900 mb-8">
          Our Blog
        </h1>

        {/* Featured Blog */}
        <div className="relative w-full mb-10 rounded-lg overflow-hidden">
          <img
            src={posts[0]?.image}
            alt="Featured Blog"
            className="w-full h-64 md:h-96 object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center text-center text-white px-4">
            <h2 className="text-xl md:text-3xl font-semibold">
              {posts[0]?.title}
            </h2>
            <p className="mt-2 text-sm md:text-lg max-w-2xl">
              {posts[0]?.content?.slice(0, 80)}...
            </p>
            <Link to={`/blog-post?id=${posts[0]?.$id}`}>
              <button className="mt-4 bg-primary hover:bg-blue-700 text-white px-6 py-1 rounded-lg transition">
                Read More
              </button>
            </Link>
          </div>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((blog) => (
            <div
              key={blog.$id}
              className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition duration-300"
            >
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-52 object-cover"
              />
              <div className="p-4">
                <p className="text-gray-500 text-sm">
                  {blog.createdAt?.slice(0, 10)}
                </p>
                <h3 className="text-lg font-semibold mt-2">{blog.title}</h3>
                <p className="text-gray-600 mt-2 text-sm">
                  {blog.content?.slice(0, 50)}...
                </p>
                <Link to={`/blog-post?id=${blog.$id}`}>
                  <button className="mt-4 bg-primary hover:bg-blue-700 text-white px-4 py-1 md:py-2 rounded-lg transition">
                    Read More
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      <BottomNavbar current="blog" />
    </>
  );
};

export default Blog;
